import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

import TopNav from "@/molecules/navbars/TopNav";

export const CartTopNav = ({ showNavbar }: { showNavbar: boolean }) => {
  const navigate = useNavigate();

  if (!showNavbar) return null;

  return (
    <TopNav
      startIconSVG={ChevronLeft}
      onStartIconClick={() => {
        navigate(-1);
      }}
      showHeaderItems={false}
    >
      <div className="flex max-h-[32px] items-center">
        <div className="flex w-full items-center justify-center text-sub2 text-primary">
          YOUR SHOPPING CART
        </div>
      </div>
    </TopNav>
  );
};
